import { Row, Col, Modal, Button, Input, Form, notification, message } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";

import { DeleteOutlined } from "@ant-design/icons";
import endpoints from "../../utils/endpoints.js";

function ModalDeleteNotification({ data, open, close }) {
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const [form] = Form.useForm();

  function handleDelete() {
    setIsButtonLoading(true);

    axios
      .post(endpoints.notification.delete, {
        data: data,
      })
      .then((resData) => {
        close();
        setIsButtonLoading(false);
        form.resetFields();
        message.success("Notificação foi apagada com sucesso!");
      })
      .catch((error) => {
        console.log(error);
        setIsButtonLoading(false);
        message.error("Algo de errado aconteceu! Tente novamente mais tarde.");
      });
  }

  function handleCloseModal() {
    close();
    form.resetFields();
  }

  return (
    <Modal
      className="modal-antd-committee"
      title={`Apagar notificação`}
      open={open}
      onCancel={handleCloseModal}
      footer={[
        <Button danger icon={<DeleteOutlined />} size="large" type="primary" onClick={handleDelete} loading={isButtonLoading} disabled={isButtonLoading}>
          Apagar
        </Button>,
        <Button size="large" onClicdk={handleCloseModal}>
          Cancelar
        </Button>,
      ]}
    >
      <Row gutter={[24, 0]}>
        <Col span={24}>
          <p>Tem a certeza que quer apagar a notificação:</p>
          <p className="font-bold text-lg mt-2">{data.title}</p>
        </Col>
      </Row>
    </Modal>
  );
}

export default ModalDeleteNotification;
